(function () {
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const update = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 6);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  document.querySelectorAll('[data-header-drawer]').forEach((drawer) => {
    drawer.addEventListener('toggle', () => {
      document.documentElement.classList.toggle('drawer-open', drawer.open);
    });
  });
})();
